import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "keys" })
export class KeysPipe implements PipeTransform {
  transform(value: any, args: string[]): any {
    console.log("value: ", value, " args: ", args);
    let keys: any[] = [];
    for (let key in value) {
      keys.push({ key: key, value: value[key].replace("_", " ") });
    }
    console.log("keys: ", keys);
    return keys;
  }
}
